import App from "./App";
import "./styles/index.css";
import { createRoot } from "react-dom/client";
import "./i18n";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<App />);
